export default "__VITE_ASSET__DhiG2mzt__"